import { types } from 'mobx-state-tree';
import * as views from './supportConversationsStoreViews';
import * as actions from './supportConversationsStoreActions';

const SupportConversationsStore = types
  .model('SupportConversationsStore', {
    // Frozen rows: read-only projections of the API's grouped inbox + thread
    groups: types.optional(types.array(types.frozen()), []),
    activeConversation: types.optional(types.frozen(), null),
    activeMessages: types.optional(types.array(types.frozen()), []),
    loading: types.optional(types.boolean, false),
    sending: types.optional(types.boolean, false)
  })
  .views(views.supportConversationsStoreViews)
  .actions(actions.supportConversationsStoreActions);

export default SupportConversationsStore;
